<template>
  <div>
    <ReportsDialog
      ref="reportsDialog"
      :report-list="reportList"
      :get-report-data="getReportData"
      title="Download Report"
    />
    <b-row align-h="end"
      ><b-col cols="12" md="6" class="me-2 mb-2">
        <b-button
           id="export-to-pdf-btn"
          class="align-right btn-fw w-100"
          @click="generateReport"
          v-b-tooltip.hover
          title="Export To PDF"
        >
          <b-icon icon="download" font-scale="1"></b-icon>
          {{ $translate("download_spreadsheet") }}
        </b-button>
      </b-col>
    </b-row>

    <b-card ref="inventoryUsageReport">
      <b-card-header class="d-flex justify-content-between">
        <h4>{{ $translate("usage_display") }}</h4>
        <span>{{ startDt }} to {{ endDt }}</span>
      </b-card-header>
      <b-card-body>
        <b-table-simple bordered responsive>
          <b-thead>
            <b-tr>
              <b-th>{{ $translate("suppliers") }}</b-th>
              <b-th
                v-for="(vendor, vIdx) in vendors"
                :key="'vendor-name' + vIdx"
                :colspan="vendor.items.length"
                class="text-center"
              >
                {{ vendor.name }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th>{{
                (settings.primary_product && settings.primary_product.title) ||
                $translate("primary_product")
              }}</b-th>
              <template v-for="(vendor, vIdx) in vendors">
                <b-th
                  v-for="(product, pIdx) in vendor.items"
                  :key="'product-name' + vIdx + pIdx"
                  class="text-center"
                >
                  {{
                    settings.bundled_product_type == "both"
                      ? `${product.name}/${product.container.name}`
                      : product.name
                  }}
                </b-th>
              </template>
            </b-tr>
            <b-tr v-for="(feature, hIdx) in features" :key="'feature' + hIdx">
              <b-th>{{ feature.title || $translate(feature.id) }}</b-th>
              <template v-for="(vendor, vIdx) in vendors">
                <b-td
                  v-for="(product, pIdx) in vendor.items"
                  :key="'product-name2' + vIdx + pIdx"
                  class="text-center"
                >
                  {{ getProductFeatureValue(product, feature) }}
                </b-td>
              </template>
            </b-tr>
          </b-tbody>
        </b-table-simple>
        <b-card class="mt-2 pageBreak" v-if="isBundled">
          <b-card-header>
            <h6>
              {{
                (settings &&
                  settings.closing_unbundled_sub_count &&
                  settings.closing_unbundled_sub_count.title) ||
                $translate("closing_unbundled_sub_count")
              }}
            </h6></b-card-header
          >
          <b-card-body>
            <b-row class="justify-content-md-center gap-4">
              <b-col
                md="3"
                cols="12"
                v-for="(item, idx) in sizes"
                :key="'size--' + idx"
              >
                <b-card
                  :header="`${item.size} ${item.uom}`"
                  bg-variant="primary"
                  text-variant="white"
                  align="center"
                  header-tag="h6"
                  header-class="mt-2"
                  header-variant="primary"
                  header-border-variant="primary"
                >
                  <b-card-text>{{ item.qty }}</b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>

        <b-card class="my-2">
          <b-card-header>
            <h6>
              {{
                (settings.secondary_items_closing_balances &&
                  settings.secondary_items_closing_balances.title) ||
                $translate("accessories")
              }}
            </h6></b-card-header
          >
          <b-card-body>
            <b-row class="justify-content-md-center gap-4">
              <b-col
                md="3"
                cols="12"
                v-for="(item, idx) in minorItemsClosingBalances"
                :key="'minorItems--' + idx"
              >
                <b-card
                  :header="item.name"
                  bg-variant="secondary"
                  text-variant="white"
                  align="center"
                  header-tag="h6"
                  header-class="mt-2"
                  header-variant="secondary"
                  header-border-variant="secondary"
                >
                  <b-card-text>{{ item.qty }}</b-card-text>
                </b-card>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import ReportsDialog from "@/components/ReportsDialog";
import dateTimeMixins from "../../mixins/dateTimeMixins";
import { templates } from "@/exports/jsreport_templates";
////import { countries } from "country-code-lookup";
////import structuredClone from "@ungap/structured-clone";
export default {
  name: "DisplayDailyUsage",
  components: {
    ReportsDialog,
  },
  mixins: [dateTimeMixins],
  data() {
    return {};
  },

  props: {
    parseItem: {
      type: Function,
      require: true,
    },
    vendors: {
      type: Array,
      default: () => [],
    },
    settings: {
      type: Object,
      default: () => ({}),
    },

    company: {
      type: Object,
      default: () => ({}),
    },
    headings: {
      type: Array,
      require: true,
    },

    minorItems: {
      type: Array,
      default: () => [],
    },
    orderTypes: {
      type: Array,
      default: () => [],
    },
    isBundled: {
      type: Boolean,
      default: false,
    },

    sectionId: { type: [Number], require: true },

    openingTime: { type: [Number], require: true },
    closingTime: { type: [Number], require: true },

    ordersWithPrimaryOrders: { type: Array, default: () => [] },
  },
  computed: {
    categories() {
      return {
        sale: "sale",
        purchase: "purchase",
        return: "return",
        loss: "loss",
        gift: "gift",
        transfer_in: "transfer_in",
        transfer_out: "transfer_out",
      };
    },
    features() {
      const { settings } = this;
      return this.headings
        .filter((id) => !!(settings[id] && settings[id].required))
        .map((id) => ({ id, title: settings[id].title }));
    },
    startDt() {
      return this.displayObjectDateTime(new Date(this.openingTime));
    },
    endDt() {
      return this.displayObjectDateTime(new Date(this.closingTime));
    },

    transactionTypeOptions() {
      return this.$store.state.transactionType.options;
    },

    reportList() {
      return [
        {
          id: "inventory_usage_report",
          value: templates.RPT_INVENTORY_USAGE_TEMPLATE,
          extension: "xlsx",
          name: "Inventory Usage Report",
        },
      ];
    },

    minorItemsClosingBalances() {
      const {
        minorItems,
        closingTime,
        openingTime,
        getBreakDowns,
        parseItem,
        sectionId,
      } = this;
      const _items = [];
      for (const product of minorItems) {
        const newItem = parseItem(product, sectionId);
        const { name } = newItem;
        const _breakdown = getBreakDowns(newItem, closingTime, openingTime);
        const qty = _breakdown.closingBalance || 0;
        _items.push({ name, qty });
      }
      _items.sort((a, b) => a.name - b.name);
      return _items;
    },

    sizes() {
      const { vendors, closingTime, openingTime, getBreakDowns } = this;
      const _sizes = [];
      for (const _vendor of vendors) {
        for (const product of _vendor.items) {
          const container = getBreakDowns(
            product.container,
            closingTime,
            openingTime
          );
          console.log("container", container);
          const { size, type } = product.container;
          const qty = container.closingBalance || 0;
          const uom = (type || {}).size_uom || "";

          let idx = _sizes.findIndex((x) => x.size == product.size);
          if (idx < 0) {
            _sizes.push({ size, qty, uom });
          } else {
            _sizes[idx].qty += qty;
          }
        }
      }
      _sizes.sort((a, b) => a.size - b.size);
      return _sizes;
    },
  },

  mounted() {},

  watch: {
    features: {
      handler: function (_features) {
        const { settings } = this;
        console.log("features:", { _features, settings });
      },
      deep: true,
    },
  },

  methods: {
    generateReport() {
      this.$refs.reportsDialog.show();
    },
    getReportData() {
      const {
        sizes,
        vendors,
        settings,
        headings,
        minorItems,
        sectionId,
        openingTime,
        closingTime,
        features,
        startDt,
        endDt,
        minorItemsClosingBalances,
        company,
        isBundled,
      } = this;

      const reportObj = {
        sizes,
        vendors,
        settings,
        headings,
        minorItems,
        sectionId,
        openingTime,
        closingTime,
        features,
        startDt,
        endDt,
        minorItemsClosingBalances,
        company,
        isBundled,
      };

      reportObj.breakdowns = [];
      for (let hIdx = 0; hIdx < features.length; hIdx++) {
        const feature = features[hIdx];
        feature.vendors = [];
        for (let vIdx = 0; vIdx < vendors.length; vIdx++) {
          const vendor = vendors[vIdx];
          const featureVendor = { products: [], vendor_id: vendor.id };
          for (let pIdx = 0; pIdx < vendor.items.length; pIdx++) {
            const product = vendor.items[pIdx];
            const value = this.getProductFeatureValue(product, feature);
            featureVendor.products.push({ value, product_id: product.id });
          }
          feature.vendors.push(featureVendor);
        }
        reportObj.breakdowns.push(feature);
      }

      console.log("ReportData:", reportObj);
      return reportObj;
    },

    getCategoryCounts(trans) {
      const {
        order: { order_type_id, id: order_id },
        added_amount,
      } = trans;

      const {
        orderTypes,
        categories,
        transactionTypeOptions: { entities, flows },
      } = this;

      const outboundFlow = flows["Outbound"];
      const inboundFlow = flows["Inbound"];
      const customerEnt = entities["Customer"];
      const officerEnt = entities["Officer"];
      const vendorEnt = entities["Vendor"];
      const internalRef = entities["Internal"];
      const blackHoleRef = entities["Black Hole"];

      const _orderType = orderTypes.find((y) => y.id == order_type_id);
      if (!_orderType) return "";

      const isInflow = added_amount >= 0;

      if (
        (_orderType.transaction_type.flow === inboundFlow &&
          _orderType.transaction_type.entity === officerEnt &&
          _orderType.transaction_type.reference_entity === customerEnt) ||
        (_orderType.transaction_type.flow === outboundFlow &&
          _orderType.transaction_type.entity === customerEnt &&
          _orderType.transaction_type.reference_entity === internalRef) ||
        (_orderType.transaction_type.flow === outboundFlow &&
          _orderType.transaction_type.entity === vendorEnt &&
          _orderType.transaction_type.reference_entity === internalRef)
      ) {
        console.log("trans sale:", trans);
        return categories.sale;
      } else if (
        _orderType.transaction_type.flow === inboundFlow &&
        _orderType.transaction_type.entity === vendorEnt &&
        _orderType.transaction_type.reference_entity === internalRef
      ) {
        return categories.purchase;
      } else if (
        (_orderType.transaction_type.flow === inboundFlow &&
          _orderType.transaction_type.entity === officerEnt &&
          _orderType.transaction_type.reference_entity === blackHoleRef) ||
        (_orderType.transaction_type.flow === inboundFlow &&
          _orderType.transaction_type.entity === internalRef &&
          _orderType.transaction_type.reference_entity === blackHoleRef)
      ) {
        return categories.loss;
      } else if (
        (_orderType.transaction_type.flow === outboundFlow &&
          _orderType.transaction_type.entity === internalRef &&
          _orderType.transaction_type.reference_entity === blackHoleRef) ||
        (_orderType.transaction_type.entity === internalRef &&
          _orderType.transaction_type.reference_entity === internalRef &&
          isInflow)
      ) {
        console.log("trans gift:", trans);
        return categories.gift;
      } else if (
        (_orderType.transaction_type.flow === inboundFlow &&
          _orderType.transaction_type.entity === customerEnt &&
          _orderType.transaction_type.reference_entity === internalRef) ||
        (_orderType.transaction_type.flow === outboundFlow &&
          _orderType.transaction_type.entity === officerEnt &&
          _orderType.transaction_type.reference_entity === customerEnt)
      ) {
        return categories.return;
      } else if (
        _orderType.transaction_type.flow === outboundFlow &&
        _orderType.transaction_type.entity === officerEnt &&
        _orderType.transaction_type.reference_entity === internalRef
      ) {
        /////check if sale or transfer out
        console.log("order_id:", order_id);
        //const isSale = true; // await this.isCustomerOrder(order_id);
        const isSale = this.ordersWithPrimaryOrders.some(
          (x) => x.id == order_id && x.has_primary_order
        );
        return isSale ? categories.sale : categories.transfer_out;
      } else if (
        _orderType.transaction_type.flow === inboundFlow &&
        _orderType.transaction_type.entity === officerEnt &&
        _orderType.transaction_type.reference_entity === internalRef
      ) {
        return categories.transfer_in;
      } else if (
        _orderType.transaction_type.entity === internalRef &&
        _orderType.transaction_type.reference_entity === internalRef
      ) {
        return isInflow ? categories.transfer_in : categories.transfer_out;
      } else if (isInflow) {
        return categories.gift;
      } else {
        return categories.loss;
      }
    },

    getProductFeatureValue(product, feature) {
      const {
        closingTime,
        openingTime,
        getBreakDowns,
        getBreakdownValue,
      } = this;
      const container = getBreakDowns(
        product.container,
        closingTime,
        openingTime
      );
      const main = getBreakDowns(product, closingTime, openingTime);
      const x = getBreakdownValue(feature.id, main, container);
      console.log("getProductFeatureValue:", x);
      return x;
    },

    getBreakDowns(product, closingTime, openingTime) {
      const convertTime = (dt_str) => this.getDateObject(dt_str).getTime();
      const section = product.section || {};
      let { transactions: _transactions } = section;
      //  const container = product.container

      _transactions = [...(_transactions || [])].map((x) => {
        x.unix_time = convertTime(x.updated_at);
        return x;
      });

      //sort in descending order
      _transactions.sort((a, b) => b.unix_time - a.unix_time);

      const closingIndex = _transactions.findIndex(
        (trx) => closingTime > trx.unix_time
      );

      const openingIndex = _transactions.findIndex(
        (trx) => openingTime > trx.unix_time
      );

      console.log("Indexes:", { openingIndex, closingIndex });

      const closingBalance = (() => {
        if (closingIndex < 0) {
          return 0;
        } else {
          return _transactions
            .slice(0, closingIndex)
            .reduce((_closingBalance, trx) => {
              _closingBalance += -trx.added_amount;
              return _closingBalance;
            }, section.quantity_on_hand || 0);
        }
      })();

      ////transactions window in correct order-- ascending
      const transactions = (() => {
        if (closingIndex >= 0 && openingIndex >= 0) {
          return _transactions.slice(closingIndex, openingIndex);
        } else if (openingIndex >= 0) {
          return _transactions.slice(0, openingIndex);
        } else if (closingIndex >= 0) {
          return _transactions.slice(closingIndex);
        } else {
          return [];
        }
      })();

      transactions.reverse();

      const openingBalance = transactions.reduce((_openingBalance, trx) => {
        _openingBalance += -trx.added_amount;
        return _openingBalance;
      }, closingBalance);

      const categories = {
        sale: 0,
        purchase: 0,
        return: 0,
        gift: 0,
        loss: 0,
        transfer_in: 0,
        transfer_out: 0,
      };

      for (const trans of transactions) {
        const type = this.getCategoryCounts(trans);
        console.log("type:", type);
        switch (type) {
          case this.categories.sale:
            categories.sale += trans.added_amount;
            break;
          case this.categories.purchase:
            categories.purchase += trans.added_amount;
            break;
          case this.categories.return:
            categories.return += trans.added_amount;
            break;
          case this.categories.loss:
            categories.loss += trans.added_amount;
            break;
          case this.categories.gift:
            categories.gift += trans.added_amount;
            break;
          case this.categories.transfer_in:
            categories.transfer_in += trans.added_amount;
            break;
          case this.categories.transfer_out:
            categories.transfer_out += trans.added_amount;
            break;
        }
      }

      return {
        closingBalance,
        openingBalance,
        transactions,
        categories,
      };
    },

    getBreakdownValue(header, main, container) {
      console.log("getBreakdownValue:", { header, main, container });
      switch (header) {
        case "opening_primary_count":
          return main.openingBalance || 0;
        case "purchases_primary_product":
          return main.categories.purchase;
        case "sales_primary_product":
          return main.categories.sale;
        case "returns_primary_product":
          return main.categories.return;
        case "transfer_in_primary_product":
          return main.categories.transfer_in;
        case "transfer_out_primary_product":
          return main.categories.transfer_out;
        case "losses_primary_product":
          return main.categories.loss;
        case "gifts_primary_product":
          return main.categories.gift;
        case "closing_primary_count":
          return main.closingBalance || 0;

        case "opening_unbundled_sub_count":
          return (container.openingBalance || 0) - (main.openingBalance || 0);
        case "purchases_unbundled_sub":
          return container.categories.purchase - main.categories.purchase;
        case "sales_unbundled_sub":
          return -(container.categories.sale - main.categories.sale);
        case "returns_unbundled_sub":
          return container.categories.return - main.categories.return;
        case "losses_unbundled_sub":
          return -(container.categories.loss - main.categories.loss);
        case "transfer_in_unbundled_sub":
          return container.categories.transfer_in - main.categories.transfer_in;
        case "transfer_out_unbundled_sub":
          return -(
            container.categories.transfer_out - main.categories.transfer_out
          );
        case "gifts_unbundled_sub":
          return container.categories.gift - main.categories.gift;
        case "closing_unbundled_sub_count":
          return (container.closingBalance || 0) - (main.closingBalance || 0);
        case "total_sub_product_count":
          return container.closingBalance || 0;

        /*  case "opening_unbundled_sub_product_count":
          return (container.openingBalance || 0) - (main.openingBalance || 0);

        case "purchases_sub_product": {
          {
            return container.categories.purchase - main.categories.purchase;
          }
        }

        case "sales_sub_product": {
          return container.categories.sale - main.categories.sale;
        }

        case "returned_unbundled_sub_product_count":
          return container.categories.return;
        case "closing_primary_count":
          return main.closingBalance || 0;
        case "closing_unbundled_sub_count":
          return (container.closingBalance || 0) - (main.closingBalance || 0);
        case "total_unbundled_sub_product_count":
          return container.closingBalance || 0; */
      }
    },
  },
};
</script>

<style></style>
